//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import BootstrapBasic from "../../../../containers/form-validations/BootstrapBasic";
import BootstrapCustom from "../../../../containers/form-validations/BootstrapCustom";
import BootstrapDefaultValues from "../../../../containers/form-validations/BootstrapDefaultValues";
import TooltipLocations from "../../../../containers/form-validations/TooltipLocations";
import TopLabels from "../../../../containers/form-validations/TopLabels";
export default {
  components: {
    "bootstrap-basic": BootstrapBasic,
    "bootstrap-custom": BootstrapCustom,
    "bootstrap-default-values": BootstrapDefaultValues,
    "tooltip-locations": TooltipLocations,
    "top-labels": TopLabels
  }
};